import ReactDOM from 'react-dom'
import createReactClass from 'create-react-class'

const modalRoot = document.getElementById('modal-root')

export default createReactClass({
  componentWillMount () {
    this.el = document.createElement('div')
  },
  componentDidMount () {
    modalRoot.appendChild(this.el)
  },

  componentWillUnmount () {
    modalRoot.removeChild(this.el)
  },

  render () {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/modal-panels/modal-wrapper.js